(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Header: shadow once the page scrolls; menu row (desktop) and search row (mobile) tuck away on scroll down */
  const header = document.querySelector('[data-wv-header]');
  if (header) {
    const wrapper = document.querySelector('.page-wrapper');
    const drawer = header.querySelector('[data-wv-drawer]');
    let lastY = 0;
    const onScroll = () => {
      const y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      header.classList.toggle('is-scrolled', y > 8);
      const busy = header.contains(document.activeElement) && document.activeElement.matches('input') || (drawer && !drawer.hidden);
      if (!busy) {
        if (y > 180 && y - lastY > 6) header.classList.add('is-condensed');
        else if (y < 120 || lastY - y > 6) header.classList.remove('is-condensed');
      }
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    wrapper?.addEventListener('scroll', onScroll, { passive: true });

    /* Mobile drawer */
    const opener = header.querySelector('[data-wv-drawer-open]');
    if (drawer && opener) {
      const panel = drawer.querySelector('.wv-drawer__panel');
      const focusables = () => $$('a[href], button:not([disabled]), input', panel).filter(el => el.offsetParent !== null);
      const open = () => {
        drawer.hidden = false;
        document.documentElement.classList.add('wv-lock');
        opener.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
        setTimeout(() => focusables()[1]?.focus({ preventScroll: true }), reduceMotion ? 0 : 120);
      };
      const close = (returnFocus = true) => {
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('wv-lock');
        opener.setAttribute('aria-expanded', 'false');
        setTimeout(() => { drawer.hidden = true; }, reduceMotion ? 0 : 320);
        if (returnFocus) opener.focus({ preventScroll: true });
      };
      opener.addEventListener('click', open);
      $$('[data-wv-drawer-close]', drawer).forEach(el => el.addEventListener('click', () => close()));
      $$('[data-wv-drawer-link]', drawer).forEach(a => a.addEventListener('click', () => close(false)));
      drawer.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        if (e.key !== 'Tab') return;
        const f = focusables();
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', e => { if (e.matches && !drawer.hidden) close(false); });
    }
  }

  /* Rotating messages in the green bar */
  $$('[data-wv-rotate]').forEach(box => {
    const items = $$('.wv-rot__item', box);
    if (items.length < 2 || reduceMotion) return;
    let i = 0, paused = false;
    box.addEventListener('mouseenter', () => { paused = true; });
    box.addEventListener('mouseleave', () => { paused = false; });
    box.addEventListener('focusin', () => { paused = true; });
    box.addEventListener('focusout', () => { paused = false; });
    setInterval(() => {
      if (paused || box.offsetParent === null) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Discount code: tap to copy */
  $$('[data-wv-copy]').forEach(btn => btn.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(btn.dataset.wvCopy); } catch (e) { return; }
    btn.classList.add('is-copied');
    setTimeout(() => btn.classList.remove('is-copied'), 1600);
  }));

  /* Topic search: suggests chapters, methods and FAQs from the book */
  $$('[data-wv-search]').forEach(form => {
    const input = form.querySelector('.wv-search__input');
    const panel = form.querySelector('.wv-search__panel');
    const list = form.querySelector('.wv-search__results');
    const empty = form.querySelector('.wv-search__empty');
    let data = [];
    try { data = JSON.parse(form.querySelector('[data-wv-search-data]').textContent); } catch (e) { return; }
    const norm = s => String(s).toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    data.forEach(d => {
      d._t = norm(d.t);
      d._i = (d.i || []).map(norm);
      d._k = norm(d.k || '');
    });
    const hrefFor = d => {
      for (const id of d.a || []) if (document.getElementById(id)) return '#' + id;
      return d.u;
    };
    const has = (hay, w) => (' ' + hay).includes(' ' + w);
    const search = q => {
      const words = norm(q).split(' ').filter(Boolean);
      if (!words.length) return [];
      const out = [];
      data.forEach(d => {
        let score = 0, sub = null;
        for (const w of words) {
          let s = 0;
          if (has(d._t, w)) s = 4;
          const hit = d._i.findIndex(x => has(x, w));
          if (hit > -1) { s = Math.max(s, 3); if (!sub && !has(d._t, w)) sub = d.i[hit]; }
          if (!s && has(d._k, w)) s = 2;
          if (!s) return;
          score += s;
        }
        if (d._t.startsWith(words.join(' '))) score += 3;
        out.push({ d, score, sub });
      });
      return out.sort((a, b) => b.score - a.score).slice(0, 6);
    };
    const mark = (text, q) => {
      const raw = q.trim();
      const at = raw.length > 1 ? text.toLowerCase().indexOf(raw.toLowerCase()) : -1;
      if (at > -1) return esc(text.slice(0, at)) + '<mark>' + esc(text.slice(at, at + raw.length)) + '</mark>' + esc(text.slice(at + raw.length));
      let html = esc(text);
      norm(q).split(' ').filter(w => w.length > 1).forEach(w => {
        html = html.replace(new RegExp('(^|[^a-z0-9])(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'), '$1<mark>$2</mark>');
      });
      return html;
    };
    const icon = d => /^Chapter (\d+)/.test(d.m) ? d.m.match(/^Chapter (\d+)/)[1]
      : d.m.startsWith('Fasting method') ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"/><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.2-2.4 3.7M12 16.6v.1"/></svg>';
    let results = [], active = -1;
    const setActive = i => {
      active = i;
      $$('li', list).forEach((li, n) => li.setAttribute('aria-selected', n === i));
      if (i > -1) { input.setAttribute('aria-activedescendant', list.children[i].id); list.children[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    };
    const render = () => {
      const q = input.value;
      form.classList.toggle('has-query', !!q.trim());
      results = search(q);
      list.innerHTML = results.map((r, n) => `<li role="option" id="${list.id}-${n}" aria-selected="false"><a href="${esc(hrefFor(r.d))}"><span class="wv-search__ico">${icon(r.d)}</span><span><span class="wv-search__t">${mark(r.d.t, q)}</span><span class="wv-search__m">${esc(r.d.m)}${r.sub ? ' · ' + mark(r.sub, q) : ''}</span></span><span class="wv-search__go"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9.5 6 6 6-6 6"/></svg></span></a></li>`).join('');
      empty.hidden = !(q.trim() && !results.length);
      if (!empty.hidden) empty.innerHTML = `Nothing matches “${esc(q.trim())}” yet. Try <b>hunger</b>, <b>hormones</b> or <b>16:8</b>, or <a href="${esc(hrefFor({ a: ['faq'], u: '/#faq' }))}">read the FAQs</a>.`;
      active = -1;
      input.removeAttribute('aria-activedescendant');
    };
    const show = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); render(); };
    const hide = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); setActive(-1); };
    input.addEventListener('focus', show);
    input.addEventListener('input', () => { panel.hidden && show(); render(); });
    input.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown' && results.length) { e.preventDefault(); panel.hidden && show(); setActive((active + 1) % results.length); }
      else if (e.key === 'ArrowUp' && results.length) { e.preventDefault(); setActive(active <= 0 ? results.length - 1 : active - 1); }
      else if (e.key === 'Escape') { if (!panel.hidden) { e.preventDefault(); hide(); } else { input.value = ''; render(); } }
    });
    form.addEventListener('submit', e => {
      const pick = results[active > -1 ? active : 0];
      if (!pick) return;
      e.preventDefault();
      list.querySelectorAll('a')[active > -1 ? active : 0].click();
    });
    list.addEventListener('click', e => {
      if (!e.target.closest('a')) return;
      hide();
      input.blur();
    });
    $$('[data-wv-topic]', form).forEach(chip => chip.addEventListener('click', () => {
      input.value = chip.dataset.wvTopic;
      input.focus();
      render();
    }));
    document.addEventListener('pointerdown', e => { if (!form.contains(e.target)) hide(); });
    form.addEventListener('focusout', e => { if (e.relatedTarget && !form.contains(e.relatedTarget)) hide(); });
  });

  /* Sticky buy bar: appears once the first buy button has scrolled away */
  const sticky = document.querySelector('.wv-sticky');
  const trigger = document.querySelector('[data-wv-sticky-trigger]');
  if (sticky && trigger && 'IntersectionObserver' in window) {
    const footer = document.querySelector('.wv-footer');
    let pastTrigger = false, footerVisible = false;
    const update = () => sticky.classList.toggle('is-visible', pastTrigger && !footerVisible);
    new IntersectionObserver(([e]) => { pastTrigger = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(trigger);
    if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); }).observe(footer);
  }

  /* Fasting clock tabs */
  $$('[data-wv-clock]').forEach(clock => {
    const tabs = $$('[role="tab"]', clock);
    const select = id => {
      tabs.forEach(t => {
        const on = t.dataset.target === id;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
      });
      $$('[data-panel]', clock).forEach(p => { p.hidden = p.dataset.panel !== id; });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t.dataset.target));
      t.addEventListener('keydown', e => {
        if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
        e.preventDefault();
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        select(next.dataset.target);
      });
    });
  });

  /* Product gallery */
  $$('[data-wv-gallery]').forEach(g => {
    const track = g.querySelector('.wv-gallery__track');
    const slides = $$('.wv-gallery__slide', g);
    const thumbs = $$('.wv-gallery__thumb', g);
    if (!track || slides.length === 0) return;
    /* Desktop: keep the whole gallery in view while it sticks, even on short screens */
    const setTop = () => {
      if (window.innerWidth < 990) { g.style.removeProperty('--wv-gallery-top'); return; }
      g.style.setProperty('--wv-gallery-top', Math.min(146, window.innerHeight - g.offsetHeight - 16) + 'px');
    };
    setTop();
    window.addEventListener('resize', setTop);
    $$('img', g).forEach(img => img.complete || img.addEventListener('load', setTop, { once: true }));
    let current = 0;
    const go = i => {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark();
    };
    const mark = () => thumbs.forEach((t, i) => t.setAttribute('aria-current', i === current));
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    g.querySelector('.wv-gallery__nav--prev')?.addEventListener('click', () => go(current - 1));
    g.querySelector('.wv-gallery__nav--next')?.addEventListener('click', () => go(current + 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; mark(); }
      });
    }, { passive: true });
  });

  /* Chapters: expand the full list on small screens */
  $$('[data-wv-more]').forEach(btn => btn.addEventListener('click', () => {
    const list = document.getElementById(btn.getAttribute('aria-controls'));
    list?.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    list?.querySelector('.wv-chapter:nth-child(5) .wv-h3')?.setAttribute('tabindex', '-1');
    list?.querySelector('.wv-chapter:nth-child(5) .wv-h3')?.focus({ preventScroll: true });
  }));
})();